import React from 'react';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import InvoicesTabs from './InvoicesTabs';
import routes from '../common/routes';

export const Invoices = () => {
  return (
    <Switch>
      <Route
        exact
        path={routes.invoices.index}
        render={() => <Redirect to={`${routes.invoices.index}${routes.invoices.types[0]}`} />}
      />
      <Route path={`${routes.invoices.index}/:invoicesType`} component={InvoicesTabs} />
    </Switch>
  );
};
